<section class="customer-onboarding-form-section">
    <h3 class="improved-page-label mb-4">Edit Onboarding Details</h3>
    <form [formGroup]="customerOnBoardingForm" name="customerOnBoardingForm"
        class="company-onboarding-form p-3 rounded-3 shadow-sm col-12 col-lg-9">
        <div class="1">
            <div class="1-upper">
                <h6 class="plus-jakarta-sans-heading customer-onboarding-form-heading mb-3">Company Details
                </h6>
                <div class="dialog__author">
                    <div class="uploadFile">
                        <input type="file" #filePicker accept="image/*" (change)="onFileChange($event)"
                            formControlName="profileImage" />
                    </div>
                    <div class="imagePreview">
                        <ng-container>
                            <a class="imagePreview__container" (click)="filePicker.click()">
                                <img [src]="imagePath + 'avatar.svg'" alt="profile-pic" *ngIf="!cropImgPreview" class="avatar">
                                <img *ngIf="cropImgPreview" [src]="cropImgPreview" class="avatar border-gray" />
                                <div class="overlay">
                                    <span class="uploadText">
                                        <i class="uploadIcon"></i> Upload
                                    </span>
                                </div>
                            </a>
                            <mat-error
                            class="w-100 increase-z-index error-top-spacing profile error-message-customer-onboarding-form-files-upload"
                            *ngIf="customerOnBoardingForm.controls['profileImage'].hasError('invalidType')">
                            Invalid file type. Please upload an image file.
                        </mat-error>
                        <mat-error class="w-100 increase-z-index error-top-spacing profile error-message-customer-onboarding-form-files-upload"
                        *ngIf="customerOnBoardingForm.controls['profileImage'].hasError('fileTooLarge')">
                            File size too large. Please upload an image smaller than 5 MB.
                          </mat-error>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="1-lower mb-3">
                <div class="company-details-lower-first container-fluid px-0 mx-0">
                    <div class="row ">
                        <div class="col-12 col-md-6 rounded-2 mb-3 d-flex flex-column">
                            <label class="improved-label-text mb-1">Company Name
                            </label>
                            <mat-form-field appearance="outline" class="improved-input">
                                <input matInput placeholder="Enter Company Name" type="text"
                                    formControlName="companyName">
                            </mat-form-field>
                            <div class="input-details-box no-mat-input justify-content-end">
                                <mat-error
                                    class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                    *ngIf="hasError(customerOnBoardingForm, 'companyName', 'whitespace')">
                                    No white space allowed.
                                </mat-error>
                                <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(customerOnBoardingForm, 'companyName', 'maxlength')">
                                Company Name must not exceed 50 characters
                            </mat-error>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 rounded-2 mb-3 d-flex flex-column">
                            <label class="improved-label-text mb-1">Email Address
                                <span class="improved-required-color">*</span>
                            </label>
                            <mat-form-field appearance="outline" class="improved-input">
                                <input matInput placeholder="Enter Email Address" type="text" formControlName="email">
                            </mat-form-field>
                            <div name="input-details-box-company-phone-number"
                                id="input-details-box-company-phone-number"
                                class="input-details-box no-mat-input justify-content-end">
                                <mat-error
                                    class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                    *ngIf="hasError(customerOnBoardingForm, 'email', 'required')">
                                    Email Address is required
                                </mat-error>
                                <mat-error
                                    class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                    *ngIf="hasError(customerOnBoardingForm, 'email', 'email')">
                                    Invalid email address
                                </mat-error>
                            </div>
                        </div>
                    </div>
                    <div class="row row-cols-2">
                        <div class="col-12 col-md-6 rounded-2 mb-3 d-flex flex-column">
                            <label class="improved-label-text mb-1">Mobile Number
                                <span class="improved-required-color">*</span>
                            </label>
                            <ngx-intl-tel-input name="input-field-company-phone-number"
                                #mobileInput
                                class="custom-country-phone-code-dropdown input plus-jakarta-sans-input" 
                                [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                                [enablePlaceholder]="true" [searchCountryFlag]="true"
                                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India"
                                [maxLength]="maxLength" [phoneValidation]="true" [separateDialCode]="true"
                                [numberFormat]="PhoneNumberFormat.International" formControlName="phoneNumber"
                                ngDefaultControl (paste)="(false)" (copy)="false">
                            </ngx-intl-tel-input>
                            <div name="input-details-box-company-phone-number"
                                id="input-details-box-company-phone-number"
                                class="input-details-box no-mat-input justify-content-end">
                                <mat-error
                                    class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                    *ngIf="hasError(customerOnBoardingForm, 'phoneNumber', 'required')">
                                    Mobile Number is required
                                </mat-error>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 rounded-2 mb-3 d-flex flex-column">
                            <label class="improved-label-text mb-1">
                                Contact Number
                            </label>
                            <ngx-intl-tel-input id="phoneInput" name="input-field-company-phone-number"
                                class="custom-country-phone-code-dropdown input plus-jakarta-sans-input"
                                [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                                [enablePlaceholder]="true" [searchCountryFlag]="true"
                                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India"
                                [maxLength]="maxLength" [phoneValidation]="true" [separateDialCode]="true"
                                [numberFormat]="PhoneNumberFormat.International" formControlName="contactNumber"
                                ngDefaultControl (paste)="(false)" (copy)="false" >
                            </ngx-intl-tel-input>
                            <div name="input-details-box-company-phone-number"
                        id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form position-relative bottom-0"
                            *ngIf="hasError(customerOnBoardingForm, 'contactNumber', 'required')">
                            Contact Number is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message plus-jakarta-sans-error-message position-relative bottom-0"
                            *ngIf="customerOnBoardingForm.controls['contactNumber'].invalid && !customerOnBoardingForm.controls['contactNumber'].errors!['required']">
                            Phone number format is invalid
                        </mat-error>
                </div>
                        </div>
                    </div>
                    <div class="row row-cols-2">
                        <div class="col-12 col-md-6 rounded-2 mb-3 d-flex flex-column">
                            <label class="improved-label-text mb-1">Website
                                <span class="improved-required-color">*</span>
                            </label>
                            <mat-form-field appearance="outline" class="improved-input">
                                <input matInput placeholder="Enter Website" type="text" formControlName="website">
                            </mat-form-field>
                            <div name="input-details-box-company-phone-number"
                                id="input-details-box-company-phone-number"
                                class="input-details-box no-mat-input justify-content-end">
                                <mat-error
                                    class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                    *ngIf="hasError(customerOnBoardingForm, 'website', 'required')">
                                    Website is required
                                </mat-error>
                                <mat-error
                                    class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                    *ngIf="hasError(customerOnBoardingForm, 'website', 'pattern')">
                                    Please enter a valid website URL
                                </mat-error>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 rounded-2 mb-3 d-flex flex-column">
                            <label class="improved-label-text mb-1">Fax Number
                            </label>
                            <mat-form-field appearance="outline" class="improved-input">
                                <input matInput placeholder="Enter Fax Number" type="text" formControlName="faxNumber">
                            </mat-form-field>
                            <div name="input-details-box-company-phone-number"
                                id="input-details-box-company-phone-number"
                                class="input-details-box no-mat-input justify-content-end">
                                <mat-error
                                    class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                    *ngIf="hasError(customerOnBoardingForm, 'faxNumber', 'pattern')">
                                    Please enter a valid Fax Number
                                </mat-error>
                            </div>
                        </div>
                    </div>
                    <div class="row row-cols-2">
                        <div class="col-12 rounded-2 mb-3 d-flex flex-column">
                            <label class="improved-label-text mb-1">Company Address
                                <span class="improved-required-color">*</span>
                            </label>
                            <mat-form-field appearance="outline" class="improved-textarea">
                                <textarea matInput placeholder="Enter Company Address" rows="3"
                                    formControlName="companyAddress"></textarea>
                            </mat-form-field>
                            <div name="input-details-box-company-phone-number"
                                id="input-details-box-company-phone-number"
                                class="input-details-box no-mat-input justify-content-end">
                                <mat-error
                                    class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                    *ngIf="hasError(customerOnBoardingForm, 'companyAddress', 'required')">
                                    Company Address is required
                                </mat-error>
                                <mat-error
                                    class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                    *ngIf="hasError(customerOnBoardingForm, 'companyAddress', 'whitespace')">
                                    No white space allowed.
                                </mat-error>
                                <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(customerOnBoardingForm, 'companyAddress', 'maxlength')">
                                Company Address must not exceed 250 characters
                            </mat-error>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="2 mb-3">
            <div class="d-flex justify-content-between align-items-center flex-wrap mb-3">
                <h6 class="plus-jakarta-sans-heading customer-onboarding-form-heading">Name & Designation of
                    principal officers/ persons to be contacted
                </h6>
                <button mat-stroked-button (click)="AddOfficer(addofficers)" class="improved-edit-button p-0">
                    <img [src]="imagePath + 'add-small-blue.svg'" alt="Edit Icon" class="profile-edit-icon me-2" />Add</button>
            </div>
            <div *ngIf="companyOfficersList.length == 0">
                <p class="no-data-found d-flex justify-content-center align-items-center my-4 h-100">No Officers
                    Available!
                </p>
            </div>
            <div *ngFor="let officer of companyOfficersList; let i = index">
                <div class="person-to-becontacted-form rounded-3 d-flex mb-3">
                    <div class="container mx-0 px-0">
                        <div class="row row-cols-6 pt-3 pb-2 ps-4 mb-2">
                            <div class="d-flex flex-column col my-3 me-3">
                                <span class="customer-onboarding-form-label-light label-light mb-1">Name</span>
                                <span class="fw-medium">{{officer.vOfficerName}}</span>
                            </div>
                            <div class="d-flex flex-column col m-3">
                                <span class="customer-onboarding-form-label-light label-light">Designation</span>
                                <span class="fw-medium">{{officer.vOfficerDesignation}}</span>
                            </div>
                            <div class="d-flex flex-column col m-3">
                                <span class="customer-onboarding-form-label-light label-light">Contact
                                    Number</span>
                                <span class="fw-medium">{{ officer.vOfficerPhoneNo}}
                                </span>
                            </div>
                            <div class="d-flex flex-column col m-3">
                                <span class="customer-onboarding-form-label-light label-light">Email
                                    Address</span>
                                <span class="fw-medium">{{officer.vOfficerEmailId}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="edit-delete-buttons d-flex pt-2 pe-2">
                        <button mat-icon-button (click)="EditOfficer(editofficers,officer)">
                            <mat-icon class="customeronboarding-edit-button">edit</mat-icon>
                        </button>
                        <button mat-icon-button (click)="DeleteOfficer(officer.iOfficersId)">
                            <mat-icon class="customeronboarding-delete-button">delete</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="3 mb-3">
            <h6 class="plus-jakarta-sans-heading customer-onboarding-form-heading">Nature of business
            </h6>
            <div class="d-flex justify-content-between">
                <div class="d-flex flex-column">
                    <div class="">
                        <mat-radio-group formControlName="natureOfBusiness">
                            <mat-radio-button [value]="1">Manufacturing</mat-radio-button>
                            <mat-radio-button [value]="2">Agent</mat-radio-button>
                            <mat-radio-button [value]="3">Sole Selling Agent</mat-radio-button>
                            <mat-radio-button [value]="4">Service Provider</mat-radio-button>
                            <mat-radio-button [value]="5">Dealer</mat-radio-button>
                            <mat-radio-button [value]="6">Trader</mat-radio-button>
                            <mat-radio-button [value]="7">MSME (Provide Certificate)</mat-radio-button>
                        </mat-radio-group>
                        <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(customerOnBoardingForm, 'companyType', 'required')">
                            Company Type is required
                        </mat-error>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="4 mb-3">
            <h6 class="plus-jakarta-sans-heading customer-onboarding-form-heading mb-2">Nature of company
            </h6>
            <div class="container-fluid mx-0 px-0">
                <div class="row row-cols-2">
                    <div class="col-12 col-md-6 rounded-2 mb-2 d-flex flex-column">
                        <label class="improved-label-text mb-1">Company Type
                            <span class="improved-required-color">*</span>
                        </label>
                        <mat-form-field appearance="outline" class="improved-input">
                            <mat-select placeholder="Select Company Type" formControlName="companyType">
                                <mat-option value="1">Propriotry</mat-option>
                                <mat-option value="2">Firm</mat-option>
                                <mat-option value="3">Private Co</mat-option>
                                <mat-option value="4">Public Ltd</mat-option>
                                <mat-option value="5">AOP/BOI</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                            class="input-details-box no-mat-input justify-content-end">
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(customerOnBoardingForm, 'companyType', 'required')">
                                Company Type is required
                            </mat-error>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 rounded-2 mb-3 d-flex flex-column">
                        <label class="improved-label-text mb-1">Years of Establishment
                            <span class="improved-required-color">*</span>
                        </label>
                        <mat-form-field appearance="outline" class="improved-input">
                            <input matInput placeholder="Enter Years of Establishment" type="text"
                                formControlName="years"  maxlength="4" pattern="^\d{1,4}$">
                        </mat-form-field>
                        <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                            class="input-details-box no-mat-input justify-content-end">
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(customerOnBoardingForm, 'years', 'required')">
                                Years of Establishment is required
                            </mat-error>
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(customerOnBoardingForm, 'years', 'pattern')">
                                Only numbers are allowed
                            </mat-error>
                            <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(customerOnBoardingForm, 'years', 'maxlength')">
                            Years of Establishment must not exceed 4 characters
                        </mat-error>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 rounded-2 mb-3 d-flex flex-column">
                        <label class="improved-label-text mb-1">GST Number
                        </label>
                        <mat-form-field appearance="outline" class="improved-input">
                            <input matInput placeholder="Enter GST Number" type="text" formControlName="gstNumber">
                        </mat-form-field>
                        <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                            class="input-details-box no-mat-input justify-content-end">
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(customerOnBoardingForm, 'gstNumber', 'pattern')">
                                Invalid GST Number format
                            </mat-error>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 rounded-2 mb-3 d-flex flex-column">
                        <label class="improved-label-text mb-1">PAN Number
                        </label>
                        <mat-form-field appearance="outline" class="improved-input">
                            <input matInput placeholder="Enter PAN Number" type="text" formControlName="panNumber">
                        </mat-form-field>
                        <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                            class="input-details-box no-mat-input justify-content-end">
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(customerOnBoardingForm, 'panNumber', 'pattern')">
                                Invalid PAN Number format
                            </mat-error>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 rounded-2 d-flex flex-column">
                        <label class="improved-label-text mb-1">Credit Terms
                        </label>
                        <mat-form-field appearance="outline" class="improved-input">
                            <input matInput placeholder="Enter Credit Terms" type="text" formControlName="creaditTerms">
                        </mat-form-field>
                        <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                            class="input-details-box no-mat-input justify-content-end">
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(customerOnBoardingForm, 'creaditTerms', 'pattern')">
                                Only alphanumeric characters are allowed
                            </mat-error>
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(customerOnBoardingForm, 'creaditTerms', 'whitespace')">
                                No white space allowed.
                            </mat-error>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="5">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h6 class="plus-jakarta-sans-heading customer-onboarding-form-heading">Offices / Factory Details
                </h6>
                <button mat-stroked-button (click)="AddFactory(addfactory)" class="improved-edit-button p-0">
                    <img [src]="imagePath + 'add-small-blue.svg'" alt="Edit Icon" class="profile-edit-icon me-2" />Add</button>
            </div>
            <div *ngIf="companyOfficesList.length == 0">
                <p class="no-data-found d-flex justify-content-center align-items-center my-4 h-100">No Factory Details
                    Available!</p>
            </div>
            <div *ngFor="let factorydetail of companyOfficesList; let i = index">
                <div class="rounded-2 factory-details-form d-flex mb-3">
                    <div class="container row py-4 ps-4 mx-0 ">
                       <div class="col-12 col-md-6 col-lg-4 d-flex flex-column">
                                <span class="customer-onboarding-form-label-light label-light">Office
                                    Name</span>
                                <span class="fw-medium">{{factorydetail.vOfficeName}}</span>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 d-flex flex-column">
                                <span class="customer-onboarding-form-label-light label-light">State</span>
                                <span class="fw-medium">{{factorydetail.vOfficeState}}</span>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 d-flex flex-column">
                                <span class="customer-onboarding-form-label-light label-light">Phone
                                    Number</span>
                                <span class="fw-medium">{{factorydetail.vOfficePhoneNo}}</span>
                            </div>
                        
                        
                            <div class="col-12 col-md-6 col-lg-4 d-flex flex-column">
                                <span class="customer-onboarding-form-label-light label-light">Fax
                                    Number</span>
                                <span class="fw-medium">{{factorydetail.vOfficeFaxNo}}</span>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 d-flex flex-column">
                                <span class="customer-onboarding-form-label-light label-light">Email
                                    Address</span>
                                <span class="fw-medium">{{factorydetail.vOfficeEmailId}}</span>
                            </div>
                        
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column">
                            <span class="customer-onboarding-form-label-light label-light">Office
                                Address</span>
                            <span class="fw-medium">{{factorydetail.txOfficeAddress}}</span>
                        </div>
                    </div>
                    <div class="d-flex">
                        <button mat-icon-button (click)="EditFactory(editfactory, factorydetail)">
                            <mat-icon class="customeronboarding-edit-button">edit</mat-icon>
                        </button>
                        <button mat-icon-button (click)="DeleteOffices(factorydetail.iOfficeId)">
                            <mat-icon class="customeronboarding-delete-button">delete</mat-icon>
                        </button>
                    </div>
                </div>

            </div>
        </div>
        <div class="6 mb-3">
            <div class="d-flex justify-content-between  align-items-center mb-3">
                <h6 class="plus-jakarta-sans-heading customer-onboarding-form-heading">Bank details (Copy of
                    Cancelled
                    Cheque Mandatory)
                </h6>
                <button mat-stroked-button (click)="AddBank(addbank)"class="improved-edit-button p-0">
                    <img [src]="imagePath + 'add-small-blue.svg'" alt="Edit Icon" class="profile-edit-icon me-2" />Add</button>
            </div>
            <div *ngIf="companyBankDetailsList.length == 0">
                <p class="no-data-found d-flex justify-content-center align-items-center my-4 h-100">No Bank Details
                    Available!</p>
            </div>
            <div *ngFor="let bankdetail of companyBankDetailsList; let i = index;">
                <div class="rounded-2 bank-details-form d-flex mb-5">
                    <div class=" container py-4 pe-5 ps-4 mx-0">
                        <div class="row row-cols-3 mb-3">
                            <div class="col-12 col-md-6 col-lg-4 d-flex flex-column">
                                <span class="customer-onboarding-form-label-light label-light">Bank
                                    Name</span>
                                <span class="fw-medium">{{bankdetail.vBankName}}</span>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 d-flex flex-column">
                                <span class="customer-onboarding-form-label-light label-light">Branch
                                    Name</span>
                                <span class="fw-medium">{{bankdetail.vBranchName}}</span>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 d-flex flex-column">
                                <span class="customer-onboarding-form-label-light label-light">Bank
                                    Account
                                    Number</span>
                                <span class="fw-medium">{{bankdetail.vBankAccNo}}</span>
                            </div>
                        </div>
                        <div class="row row-cols-3  mb-3">
                            <div class="col-12 col-md-6 col-lg-4 d-flex flex-column">
                                <span class="customer-onboarding-form-label-light label-light">RTGS/IFSC
                                    Number</span>
                                <span class="fw-medium">{{bankdetail.vIfscCode}}</span>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 d-flex flex-column">
                                <span class="customer-onboarding-form-label-light label-light">IBAN
                                    Number</span>
                                <span class="fw-medium">{{bankdetail.vIbanNo}}</span>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 d-flex flex-column">
                                <span class="customer-onboarding-form-label-light label-light">Swift
                                    Code</span>
                                <span class="fw-medium">{{bankdetail.vSwiftCode}}</span>
                            </div>
                        </div>
                        <div class="col-12  mb-3">
                            <span class="customer-onboarding-form-label-light label-light">Cheque
                                Photo: </span>
                            <span class="fw-medium link">{{ removeFakePath(bankdetail.txChequeFile) }}</span>
                        </div>
                    </div>
                    <div class="d-flex">
                        <button mat-icon-button (click)="EditBank(editbank,bankdetail)">
                            <mat-icon class="customeronboarding-edit-button">edit</mat-icon>
                        </button>
                        <button mat-icon-button (click)="DeleteBankDetails(bankdetail.iBankDetailId)">
                            <mat-icon class="customeronboarding-delete-button">delete</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="7 mb-5">Declaration</div> -->
        <div>
            <div class="button-container">
                <button class="cancle-btn" (click)="backToOnboarding()">Cancel</button>
                <button type="submit" class="submit-btn" (click)="EditcustomerOnboardingProcess()">Save Changes</button>
            </div>
        </div>
    </form>
</section>

<ng-template #addofficers let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="modal-header improved-cof-modal-header">
            <h4 class="modal-title" id="modal-basic-title">Add Officers</h4>
            <button type="button" class="btn-close close  custom-close-button" aria-label="Close"
                (click)="d('Cross click')">
            </button>
        </div>
        <div class="modal-body improved-cof-modal-body">
            <form [formGroup]="addNewOfficersForm" >
                <div class="d-flex flex-column mb-3">
                    <label for="firstName" class="improved-label-text mb-1">Name
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="firstName" type="text" placeholder="Enter Name" formControlName="name">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewOfficersForm, 'name', 'required')">
                            Name is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewOfficersForm, 'name', 'whitespace')">
                            No white space allowed.
                        </mat-error>
                        <mat-error
                        class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                        *ngIf="hasError(addNewOfficersForm, 'name', 'maxlength')">
                        Name must not exceed 50 characters
                    </mat-error>
                    </div>
                </div>

                <div class="modal-body-phone mb-3 d-flex flex-column">
                    <label for="phoneNumber" name="company-phone-number-label" class="improved-label-text mb-1">
                        Contact Number
                        <span class="improved-required-color">*</span>
                    </label>
                    <ngx-intl-tel-input name="input-field-company-phone-number" id="input-field-company-phone-number"
                        class="custom-country-phone-code-dropdown input plus-jakarta-sans-input modal-body-phone-input"
                        [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                        [enablePlaceholder]="true" [searchCountryFlag]="true"
                        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                        [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="maxLength"
                        [phoneValidation]="true" [separateDialCode]="true" [numberFormat]="PhoneNumberFormat.International"
                        formControlName="contactNumber" ngDefaultControl (paste)="(false)" (copy)="false">
                    </ngx-intl-tel-input>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewOfficersForm, 'contactNumber', 'required')">
                            Contact Number is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message plus-jakarta-sans-error-message"
                            *ngIf="addNewOfficersForm.controls['contactNumber'].invalid && !addNewOfficersForm.controls['contactNumber'].errors!['required']">
                            Phone number format is invalid
                        </mat-error>
                    </div>
                </div>

                <div class="mb-3 d-flex flex-column">
                    <label for="" class="improved-label-text mb-1">Designation
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput type="text" placeholder="Enter Designation" formControlName="designation">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewOfficersForm, 'designation', 'required')">
                            Designation is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewOfficersForm, 'designation', 'whitespace')">
                            No white space allowed.
                        </mat-error>
                        <mat-error
                        class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                        *ngIf="hasError(addNewOfficersForm, 'designation', 'maxlength')">
                        Designation must not exceed 30 characters
                    </mat-error>
                    </div>
                </div>


                <div class="d-flex flex-column">
                    <label for="email" class="improved-label-text mb-1">Email Address
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="email" formControlName="email" type="email"
                            placeholder="Enter Email Address">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewOfficersForm, 'email', 'required')">
                            Email Address is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewOfficersForm, 'email', 'email')">
                            Invalid email address
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewOfficersForm, 'email', 'whitespace')">
                            No white space allowed.
                        </mat-error>
                    </div>
                </div>

                
            </form>
        </div>
        <div class="d-flex justify-content-end modal-footer">
            <div class="custom-button ">
                <button class="cancel-button me-3"
                (click)="d('Cross click')">Cancel</button>
              </div>
            <button type="submit" class="btn btn-primary improved-add-btn" (click)="AddNewOfficer()">Add</button>
        </div>
    </div>
</ng-template>

<ng-template #addfactory let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="modal-header improved-cof-modal-header">
            <h4 class="modal-title" id="modal-basic-title">Add Factory</h4>
            <button type="button" class="btn-close close  custom-close-button" aria-label="Close"
                (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body improved-cof-modal-body">
            <form [formGroup]="addNewFactoryForm">
                <div class="d-flex flex-column mb-3">
                    <label for="firstName" class="improved-label-text mb-1">First Name
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="firstName" type="text" placeholder="Enter Office Name"
                            formControlName="firstName">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewFactoryForm, 'firstName', 'required')">
                            First Name is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewFactoryForm, 'firstName', 'whitespace')">
                            No white space allowed.
                        </mat-error>
                        <mat-error
                        class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                        *ngIf="hasError(addNewFactoryForm, 'firstName', 'maxlength')">
                        First Name must not exceed 50 characters
                    </mat-error>
                    </div>
                </div>
                <div class="d-flex flex-column mb-3">
                    <label for="" class="improved-label-text mb-1">State
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput type="text" placeholder="Enter State" formControlName="state">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewFactoryForm, 'state', 'required')">
                            State is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewFactoryForm, 'state', 'whitespace')">
                            No white space allowed.
                        </mat-error>
                        <mat-error
                        class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                        *ngIf="hasError(addNewFactoryForm, 'state', 'maxlength')">
                        State must not exceed 30 characters
                    </mat-error>
                    </div>
                </div>
                <div class="modal-body-phone mb-3 d-flex flex-column">
                    <label for="phoneNumber" name="company-phone-number-label" class="improved-label-text">
                        Contact Number
                        <span class="improved-required-color">*</span>
                    </label>
                    <ngx-intl-tel-input name="input-field-company-phone-number" id="input-field-company-phone-number"
                        class="custom-country-phone-code-dropdown input plus-jakarta-sans-input modal-body-phone-input"
                        [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                        [enablePlaceholder]="true" [searchCountryFlag]="true"
                        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                        [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="maxLength"
                        [phoneValidation]="true" [separateDialCode]="true" [numberFormat]="PhoneNumberFormat.International"
                        formControlName="contactNumber" ngDefaultControl (paste)="(false)" (copy)="false">
                    </ngx-intl-tel-input>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewFactoryForm, 'contactNumber', 'required')">
                            Contact Number is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message plus-jakarta-sans-error-message"
                            *ngIf="addNewFactoryForm.controls['contactNumber'].invalid && !addNewFactoryForm.controls['contactNumber'].errors!['required']">
                            Phone number format is invalid
                        </mat-error>
                    </div>
                </div>
                <div class="d-flex flex-column mb-3">
                    <label for="email" class="improved-label-text mb-1">Email Address
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="email" formControlName="email" type="email"
                            placeholder="Enter Email Address">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewFactoryForm, 'email', 'required')">
                            Email Address is required
                        </mat-error>
                        <mat-error
                        class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                        *ngIf="hasError(addNewFactoryForm, 'email', 'email')">
                        Invalid email address
                    </mat-error>
                    </div>
                </div>
                <div class="d-flex flex-column mb-3">
                    <label for="fax" class="improved-label-text mb-1">Fax Number
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="fax" formControlName="faxNumber" type="email"
                            placeholder="Enter Fax Number">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewFactoryForm, 'faxNumber', 'required')">
                            Fax Number is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewFactoryForm, 'faxNumber', 'pattern')">
                            Please enter a valid Fax Number
                        </mat-error>
                    </div>
                </div>
                <div class="d-flex flex-column">
                    <label for="officeaddress" class="improved-label-text mb-1">Office Address
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="officeaddress" formControlName="officeAddress" type="officeaddress"
                            placeholder="Enter Office Address">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewFactoryForm, 'officeAddress', 'required')">
                            Office Address is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewFactoryForm, 'officeAddress', 'whitespace')">
                            No white space allowed.
                        </mat-error>
                        <mat-error
                        class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                        *ngIf="hasError(addNewFactoryForm, 'officeAddress', 'maxlength')">
                        Office Address must not exceed 250 characters
                    </mat-error>
                    </div>
                </div>

            </form>
        </div>
        <div class="d-flex justify-content-end modal-footer">
            <div class="custom-button ">
                <button class="cancel-button me-3"
                (click)="d('Cross click')">Cancel</button>
              </div>
            <button type="submit" class="btn btn-primary improved-add-btn"
                (click)="AddNewfactory()">Add</button>
        </div>
    </div>
</ng-template>


<ng-template #addbank let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="modal-header improved-cof-modal-header">
            <h4 class="modal-title" id="modal-basic-title">Add Bank</h4>
            <button type="button" class="btn-close close  custom-close-button" aria-label="Close"
                (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body improved-cof-modal-body">
            <form [formGroup]="addNewBankForm" >
                <div class="d-flex flex-column mb-3">
                    <label for="bankName" class="improved-label-text mb-1">Bank Name
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="bankName" formControlName="bankName" type="text"
                            placeholder="Enter Bank Name">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewBankForm, 'bankName', 'required')">
                            Bank Name is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewBankForm, 'bankName', 'whitespace')">
                            No white space allowed.
                        </mat-error>
                        <mat-error
                        class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                        *ngIf="hasError(addNewBankForm, 'bankName', 'maxlength')">
                        Bank Name must not exceed 50 characters
                    </mat-error>
                    </div>
                </div>
                <div class="d-flex flex-column mb-3">
                    <label for="branchName" class="improved-label-text mb-1">Branch
                        Name
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="branchName" formControlName="branchName" type="text"
                            placeholder="Enter Branch Name">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewBankForm, 'branchName', 'required')">
                            Branch Name is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewBankForm, 'branchName', 'whitespace')">
                            No white space allowed.
                        </mat-error>
                        <mat-error
                        class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                        *ngIf="hasError(addNewBankForm, 'branchName', 'maxlength')">
                        Branch Name must not exceed 50 characters
                    </mat-error>
                    </div>
                </div>
                <div class="d-flex flex-column mb-3">
                    <label for="bankAccountNumber" class="improved-label-text mb-1">Bank
                        Account Number
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="bankAccountNumber" formControlName="bankAccountNumber" type="text"
                            placeholder="Enter Bank Account Number">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewBankForm, 'bankAccountNumber', 'required')">
                            Bank Account Number is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="addNewBankForm.get('bankAccountNumber')?.errors?.['pattern'] && !addNewBankForm.get('bankAccountNumber')?.errors?.['required']">
                            Only numeric characters are allowed
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="addNewBankForm.get('bankAccountNumber')?.errors?.['minlength'] && !addNewBankForm.get('bankAccountNumber')?.errors?.['pattern']">
                            Bank Account Number must be at least 6 digits long
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="addNewBankForm.get('bankAccountNumber')?.errors?.['maxlength'] && !addNewBankForm.get('bankAccountNumber')?.errors?.['minlength']">
                            Bank Account Number cannot exceed 16 digits
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="addNewBankForm.get('bankAccountNumber')?.errors?.['whitespace'] && !addNewBankForm.get('bankAccountNumber')?.errors?.['maxlength']">
                            No leading or trailing whitespace allowed
                        </mat-error>
                    </div>
                </div>
                
                <div class="d-flex flex-column mb-3">
                    <label for="ifscNumber" class="improved-label-text mb-1">RTGS / IFSC
                        Number
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="ifscNumber" formControlName="ifscNumber" type="text"
                            placeholder="Enter RTGS / IFSC Number">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewBankForm, 'ifscNumber', 'required')">
                            RTGS / IFSC Number is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewBankForm, 'ifscNumber', 'pattern')">
                            Invalid RTGS / IFSC Number format. Use 11 characters: 4 letters followed by '0' and then 6
                            alphanumeric characters.
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewBankForm, 'ifscNumber', 'whitespace')">
                            No whitespace allowed.
                        </mat-error>
                    </div>
                </div>
                <div class="d-flex flex-column mb-3">
                    <label for="ibanNumber" class="improved-label-text mb-1">IBAN
                        Number
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="ibanNumber" formControlName="ibanNumber" type="text"
                            placeholder="Enter IBAN Number">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewBankForm, 'ibanNumber', 'required')">
                            IBAN Number is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewBankForm, 'ibanNumber', 'pattern')">
                            Invalid IBAN format. Please use the correct format (e.g., XX00XXXXXXXXXXXXXX).
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewBankForm, 'ibanNumber', 'whitespace')">
                            No whitespace allowed
                        </mat-error>
                    </div>
                </div>
                <div class="d-flex flex-column mb-3">
                    <label for="swiftCode" class="improved-label-text mb-1">Swift Code
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="swiftCode" formControlName="swiftCode" type="text"
                            placeholder="Enter Swift Code">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewBankForm, 'swiftCode', 'required')">
                            Swift Code is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewBankForm, 'swiftCode', 'pattern')">
                            Invalid Swift Code format. Please enter a valid code (8 or 11 characters).
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(addNewBankForm, 'swiftCode', 'whitespace')">
                            No whitespace allowed.
                        </mat-error>
                    </div>
                </div>

                <div class="d-flex flex-column">
                    <div class="file-upload-container">
                        <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload
                            formControlName="bankDocument" accept="application/pdf">

                        <div class="file-upload d-flex justify-content-center align-items-center">{{fileName || "No file uploaded yet."}}
                            <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUpload.click()">
                                <mat-icon>attach_file</mat-icon>
                            </button>
                            <span class="improved-required-color">*</span>
                        </div>
                        <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error class="w-100 increase-z-index error-top-spacing profile error-message-customer-onboarding-form"
                                   *ngIf="hasError(addNewBankForm, 'bankDocument', 'required')">
                            Bank Document is required
                        </mat-error>
                        <mat-error class="w-100 increase-z-index error-top-spacing profile  error-message-customer-onboarding-form"
                                   *ngIf="fileTypeError">
                            Only PDF files are allowed.
                        </mat-error>
                    </div>
                    </div>
                </div>
               
            </form>
        </div>
        <div class="d-flex justify-content-end modal-footer">
            <div class="custom-button ">
                <button class="cancel-button me-3"
                (click)="d('Cross click')">Cancel</button>
              </div>
            <button type="submit" class="btn btn-primary improved-add-btn" (click)="AddNewBank()">Add</button>
        </div>
    </div>
</ng-template>


<ng-template #editofficers let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="modal-header improved-cof-modal-header">
            <h4 class="modal-title" id="modal-basic-title">Edit Officers</h4>
            <button type="button" class="btn-close close  custom-close-button" aria-label="Close"
                (click)="d('Cross click')">
            </button>
        </div>
        <div class="modal-body improved-cof-modal-body">
            <form [formGroup]="editOfficersForm">
                <div class="d-flex flex-column mb-3">
                    <label for="firstName" class="improved-label-text mb-1">Name
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="firstName" type="text" placeholder="Enter Name" formControlName="name">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editOfficersForm, 'name', 'required')">
                            Name is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editOfficersForm, 'name', 'whitespace')">
                            No white space allowed.
                        </mat-error>
                        <mat-error
                        class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                        *ngIf="hasError(editOfficersForm, 'name', 'maxlength')">
                        Name must not exceed 50 characters
                    </mat-error>
                    </div>
                </div>

                <div class="modal-body-phone mb-3 d-flex flex-column">
                    <label for="phoneNumber" name="company-phone-number-label" class="improved-label-text mb-1">
                        Contact Number
                        <span class="improved-required-color">*</span>
                    </label>
                    <ngx-intl-tel-input name="input-field-company-phone-number" id="input-field-company-phone-number"
                        class="custom-country-phone-code-dropdown input plus-jakarta-sans-input modal-body-phone-input"
                        [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                        [enablePlaceholder]="true" [searchCountryFlag]="true"
                        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                        [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="maxLength"
                        [phoneValidation]="true" [separateDialCode]="true" [numberFormat]="PhoneNumberFormat.International"
                        formControlName="contactNumber" ngDefaultControl (paste)="(false)" (copy)="false">
                    </ngx-intl-tel-input>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editOfficersForm, 'contactNumber', 'required')">
                            Contact Number is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message plus-jakarta-sans-error-message"
                            *ngIf="editOfficersForm.controls['contactNumber'].invalid && !editOfficersForm.controls['contactNumber'].errors!['required']">
                            Phone number format is invalid
                        </mat-error>
                    </div>
                </div>

                <div class="mb-3 d-flex flex-column">
                    <label for="" class="improved-label-text mb-1">Designation
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput type="text" placeholder="Enter Designation" formControlName="designation">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editOfficersForm, 'designation', 'required')">
                            Designation is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editOfficersForm, 'designation', 'whitespace')">
                            No white space allowed.
                        </mat-error>
                        <mat-error
                        class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                        *ngIf="hasError(editOfficersForm, 'designation', 'maxlength')">
                        Designation must not exceed 30 characters
                    </mat-error>
                    </div>
                </div>


                <div class="mb-3 d-flex flex-column">
                    <label for="email" class="improved-label-text mb-1">Email Address
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="email" formControlName="email" type="email"
                            placeholder="Enter Email Address">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editOfficersForm, 'email', 'required')">
                            Email Address is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editOfficersForm, 'email', 'email')">
                            Invalid email address
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editOfficersForm, 'email', 'whitespace')">
                            No white space allowed.
                        </mat-error>
                    </div>
                </div>
                
            </form>
    </div>
    <div class="d-flex justify-content-end modal-footer">
        <div class="custom-button ">
            <button class="cancel-button me-3"
            (click)="d('Cross click')">Cancel</button>
          </div>
        <button type="submit" class="btn btn-primary improved-add-btn" (click)="AddEditOfficer()">Save Changes</button>
    </div>
    </div>
</ng-template>

<ng-template #editfactory let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="modal-header improved-cof-modal-header">
            <h4 class="modal-title" id="modal-basic-title">Edit Offices</h4>
            <button type="button" class="btn-close close  custom-close-button" aria-label="Close"
                (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body improved-cof-modal-body">
            <form [formGroup]="editFactoryForm" >
                <div class="d-flex flex-column mb-3">
                    <label for="firstName" class="improved-label-text mb-1">First Name
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="firstName" type="text" placeholder="Enter Office Name"
                            formControlName="firstName">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editFactoryForm, 'firstName', 'required')">
                            First Name is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editFactoryForm, 'firstName', 'whitespace')">
                            No white space allowed.
                        </mat-error>
                        <mat-error
                        class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                        *ngIf="hasError(editFactoryForm, 'firstName', 'maxlength')">
                        First Name must not exceed 50 characters
                    </mat-error>
                    </div>
                </div>
                <div class="d-flex flex-column mb-3">
                    <label for="" class="improved-label-text mb-1">State
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput type="text" placeholder="Enter State" formControlName="state">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editFactoryForm, 'state', 'required')">
                            State is required
                        </mat-error>
                        <mat-error class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                        *ngIf="hasError(editFactoryForm, 'state', 'whitespace')">
                        No white space allowed.
                    </mat-error>
                    <mat-error
                    class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                    *ngIf="hasError(editFactoryForm, 'state', 'maxlength')">
                    State must not exceed 30 characters
                </mat-error>
                    </div>
                </div>
                <div class="modal-body-phone mb-3 d-flex flex-column">
                    <label for="phoneNumber" name="company-phone-number-label" class="improved-label-text">
                        Contact Number
                        <span class="improved-required-color">*</span>
                    </label>
                    <ngx-intl-tel-input name="input-field-company-phone-number" id="input-field-company-phone-number"
                        class="custom-country-phone-code-dropdown input plus-jakarta-sans-input modal-body-phone-input"
                        [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                        [enablePlaceholder]="true" [searchCountryFlag]="true"
                        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                        [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="maxLength"
                        [phoneValidation]="true" [separateDialCode]="true" [numberFormat]="PhoneNumberFormat.International"
                        formControlName="contactNumber" ngDefaultControl (paste)="(false)" (copy)="false">
                    </ngx-intl-tel-input>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editFactoryForm, 'contactNumber', 'required')">
                            Contact Number is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message plus-jakarta-sans-error-message"
                            *ngIf="editFactoryForm.controls['contactNumber'].invalid && !editFactoryForm.controls['contactNumber'].errors!['required']">
                            Contact Number format is invalid
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editFactoryForm, 'contactNumber', 'whitespace')">
                            No white space allowed.
                        </mat-error>
                    </div>
                </div>
                <div class="d-flex flex-column mb-3">
                    <label for="email" class="improved-label-text mb-1">Email Address
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="email" formControlName="email" type="email"
                            placeholder="Enter Email Address">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editFactoryForm, 'email', 'required')">
                            Email Address is required
                        </mat-error>
                        <mat-error
                        class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                        *ngIf="hasError(editFactoryForm, 'email', 'email')">
                        Invalid email address
                    </mat-error>
                    </div>
                </div>
                <div class="d-flex flex-column mb-3">
                    <label for="fax" class="improved-label-text mb-1">Fax Number
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="fax" formControlName="faxNumber" type="email"
                            placeholder="Enter Fax Number">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editFactoryForm, 'faxNumber', 'required')">
                            Fax Number is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editFactoryForm, 'faxNumber', 'pattern')">
                            Please enter a valid Fax Number
                        </mat-error>
                    </div>
                </div>
                <div class="d-flex flex-column">
                    <label for="officeaddress" class="improved-label-text mb-1">Office Address
                        <span class="improved-required-color">*</span>
                    </label>
                    <mat-form-field appearance="outline" class="improved-input">
                        <input matInput id="officeaddress" formControlName="officeAddress" type="officeaddress"
                            placeholder="Enter Office Address">
                    </mat-form-field>
                    <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editFactoryForm, 'officeAddress', 'required')">
                            Office Address is required
                        </mat-error>
                        <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editFactoryForm, 'officeAddress', 'whitespace')">
                            No white space allowed.
                        </mat-error>
                        <mat-error
                        class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                        *ngIf="hasError(editFactoryForm, 'officeAddress', 'maxlength')">
                        Office Address must not exceed 250 characters
                    </mat-error>
                    </div>
                </div>

            </form>
        </div>
        <div class="d-flex justify-content-end modal-footer">
            <div class="custom-button ">
                <button class="cancel-button me-3"
                (click)="d('Cross click')">Cancel</button>
              </div>
            <button type="submit" class="btn btn-primary improved-add-btn" (click)="AddEditfactory()">Save Changes</button>
        </div>
    </div>
</ng-template>

<ng-template #editbank let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="modal-header improved-cof-modal-header">
            <h4 class="modal-title" id="modal-basic-title">Edit Bank Details</h4>
            <button type="button" class="btn-close close  custom-close-button" aria-label="Close"
                (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body improved-cof-modal-body">
            <form [formGroup]="editBankForm" >
                    <div class="d-flex flex-column mb-3">
                        <label for="bankName" class="improved-label-text mb-1">Bank Name
                            <span class="improved-required-color">*</span>
                        </label>
                        <mat-form-field appearance="outline" class="improved-input">
                            <input matInput id="bankName" formControlName="bankName" type="text"
                                placeholder="Enter Bank Name">
                        </mat-form-field>
                        <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                            class="input-details-box no-mat-input justify-content-end">
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'bankName', 'required')">
                                Bank Name is required
                            </mat-error>
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'bankName', 'whitespace')">
                                No white space allowed.
                            </mat-error>
                            <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editBankForm, 'bankName', 'maxlength')">
                            Bank Name must not exceed 50 characters
                        </mat-error>
                        </div>
                    </div>
                    <div class="d-flex flex-column mb-3">
                        <label for="branchName" class="improved-label-text mb-1">Branch
                            Name
                            <span class="improved-required-color">*</span>
                        </label>
                        <mat-form-field appearance="outline" class="improved-input">
                            <input matInput id="branchName" formControlName="branchName" type="text"
                                placeholder="Enter Branch Name">
                        </mat-form-field>
                        <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                            class="input-details-box no-mat-input justify-content-end">
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'branchName', 'required')">
                                Branch Name is required
                            </mat-error>
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'branchName', 'whitespace')">
                                No white space allowed.
                            </mat-error>
                            <mat-error
                            class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                            *ngIf="hasError(editBankForm, 'branchName', 'maxlength')">
                            Branch Name must not exceed 50 characters
                        </mat-error>
                        </div>
                    </div>
                    <div class="d-flex flex-column mb-3">
                        <label for="bankAccountNumber" class="improved-label-text mb-1">Bank
                            Account Number
                            <span class="improved-required-color">*</span>
                        </label>
                        <mat-form-field appearance="outline" class="improved-input">
                            <input matInput id="bankAccountNumber" formControlName="bankAccountNumber" type="text"
                                placeholder="Enter Bank Account Number">
                        </mat-form-field>
                        <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                            class="input-details-box no-mat-input justify-content-end">
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'bankAccountNumber', 'required')">
                                Bank Account Number is required
                            </mat-error>
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'bankAccountNumber', 'pattern')">
                                Only numeric characters are allowed
                            </mat-error>
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'bankAccountNumber', 'minlength')">
                                Bank Account Number must be at least 6 digits long
                            </mat-error>
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'bankAccountNumber', 'maxlength')">
                                Bank Account Number cannot exceed 16 digits
                            </mat-error>
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'bankAccountNumber', 'whitespace')">
                                No leading or trailing whitespace allowed
                            </mat-error>
                        </div>
                    </div>
                    <div class="d-flex flex-column mb-3">
                        <label for="ifscNumber" class="improved-label-text mb-1">RTGS / IFSC
                            Number
                            <span class="improved-required-color">*</span>
                        </label>
                        <mat-form-field appearance="outline" class="improved-input">
                            <input matInput id="ifscNumber" formControlName="ifscNumber" type="text"
                                placeholder="Enter RTGS / IFSC Number">
                        </mat-form-field>
                        <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                            class="input-details-box no-mat-input justify-content-end">
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'ifscNumber', 'required')">
                                RTGS / IFSC Number is required
                            </mat-error>
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'ifscNumber', 'pattern')">
                                Invalid RTGS / IFSC Number format. Use 11 characters: 4 letters followed by '0' and then
                                6
                                alphanumeric characters.
                            </mat-error>
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'ifscNumber', 'whitespace')">
                                No whitespace allowed.
                            </mat-error>
                        </div>
                    </div>
                    <div class="d-flex flex-column mb-3">
                        <label for="ibanNumber" class="improved-label-text mb-1">IBAN
                            Number
                            <span class="improved-required-color">*</span>
                        </label>
                        <mat-form-field appearance="outline" class="improved-input">
                            <input matInput id="ibanNumber" formControlName="ibanNumber" type="text"
                                placeholder="Enter IBAN Number">
                        </mat-form-field>
                        <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                            class="input-details-box no-mat-input justify-content-end">
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'ibanNumber', 'required')">
                                IBAN Number is required
                            </mat-error>
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'ibanNumber', 'pattern')">
                                Invalid IBAN format. Please use the correct format (e.g., XX00XXXXXXXXXXXXXX).
                            </mat-error>
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'ibanNumber', 'whitespace')">
                                No whitespace allowed
                            </mat-error>
                        </div>
                    </div>
                    <div class="d-flex flex-column mb-3">
                        <label for="swiftCode" class="improved-label-text mb-1">Swift Code
                            <span class="improved-required-color">*</span>
                        </label>
                        <mat-form-field appearance="outline" class="improved-input">
                            <input matInput id="swiftCode" formControlName="swiftCode" type="text"
                                placeholder="Enter Swift Code">
                        </mat-form-field>
                        <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                            class="input-details-box no-mat-input justify-content-end">
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'swiftCode', 'required')">
                                Swift Code is required
                            </mat-error>
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'swiftCode', 'pattern')">
                                Invalid Swift Code format. Please enter a valid code (8 or 11 characters).
                            </mat-error>
                            <mat-error
                                class="w-100 increase-z-index error-top-spacing error-message-customer-onboarding-form"
                                *ngIf="hasError(editBankForm, 'swiftCode', 'whitespace')">
                                No whitespace allowed.
                            </mat-error>
                        </div>
                    </div>
          <div class="pb-4 d-flex flex-column">
                    <div class="file-upload-container">
                        <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload
                            formControlName="bankDocument" accept="application/pdf">

                        <div class="file-upload d-flex justify-content-center align-items-center">{{fileName || "No file uploaded yet."}}
                            <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUpload.click()">
                                <mat-icon>attach_file</mat-icon>
                            </button>
                            <span class="improved-required-color">*</span>
                        </div>
                        <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                        class="input-details-box no-mat-input justify-content-end">
                        <mat-error class="w-100 increase-z-index error-top-spacing profile error-message-customer-onboarding-form"
                                   *ngIf="hasError(editBankForm, 'bankDocument', 'required')">
                            Bank Document is required
                        </mat-error>
                        <mat-error class="w-100 increase-z-index error-top-spacing profile  error-message-customer-onboarding-form"
                                   *ngIf="fileTypeError">
                            Only PDF files are allowed.
                        </mat-error>
                    </div>
                    </div>
                </div>
                
            </form>
        </div>
        <div class="d-flex justify-content-end modal-footer">
            <button type="submit" class="cancel-button me-3" (click)="d('Cross click')">Cancel</button>
            <button type="submit" (click)="AddEditBank()"
                class="btn btn-primary improved-add-btn">Save Changes</button>
        </div>
    </div>
</ng-template>

<ng-template #cropModal let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Crop Image</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="closeCropperModal();modal.dismiss('Cross click')">
      </button>
    </div>
    <div class="modal-body crop-modal-body">
      <image-cropper 
        [imageChangedEvent]="imgChangeEvt" 
        [maintainAspectRatio]="true" 
        [aspectRatio]="1 / 1"
        [resizeToWidth]="256" 
        format="png" 
        (imageCropped)="cropImg($event)" 
        (imageLoaded)="imgLoad()"
        (cropperReady)="initCropper()" 
        (loadImageFailed)="imgFailed()">
      </image-cropper>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="onCropDone(modal)">Done</button>
    </div>
  </ng-template>